import { useState } from 'react';
import { ChevronRight, Clock } from 'lucide-react';
import { SessionByDateDto } from '@repo/shared/dtos/my-insights/SessionByDateDto';
import { SessionItem } from './ui/SessionItem';

interface SessionsListProps {
  sessions: SessionByDateDto[];
  onSelectSession: (sessionId: string) => void;
  selectedSessionId?: string;
}

export const SessionsList = ({
  sessions,
  onSelectSession,
  selectedSessionId,
}: SessionsListProps) => {
  const [expanded, setExpanded] = useState(false);

  if (sessions.length === 0) return null;

  const toggleExpanded = () => setExpanded(prev => !prev);

  return (
    <div className="rounded-lg border border-gray-100 bg-white shadow-sm">
      <div
        className="flex cursor-pointer items-center justify-between p-3 transition-colors hover:bg-gray-50"
        onClick={toggleExpanded}
      >
        <div className="flex items-center">
          <Clock className="mr-2 h-4 w-4 text-indigo-500" />
          <span className="font-medium text-gray-700">Available Sessions ({sessions.length})</span>
        </div>
        <ChevronRight
          className={`h-4 w-4 text-gray-400 transition-transform duration-200 ${
            expanded ? 'rotate-90 transform' : ''
          }`}
        />
      </div>

      {expanded && (
        <div className="space-y-2 px-3 pb-3">
          <div className="mb-3 flex items-center text-xs text-gray-500">
            <div className="mr-2 h-2 w-2 rounded-full bg-gray-400"></div>
            <span>Colors match chart markers (dashed lines show session start/end)</span>
          </div>

          <div className="flex flex-col gap-2" role="list" aria-label="Available sessions">
            {sessions.map((session, index) => (
              <SessionItem
                key={session.id}
                session={session}
                index={index}
                isSelected={selectedSessionId === session.id}
                onSelect={onSelectSession}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
